"use client";

import { ErrorFallback, type ErrorFallbackProps } from "@/platform/observability/ui/client";

// A page that failed to render: the message, a retry and a reference in the
// page's language, and a report to the site's own error endpoint (D-043).
export default function PageError(props: ErrorFallbackProps) {
  return <ErrorFallback {...props} />;
}
